<template>
  <div>
    <p class="title">{{ popupContent.title }}</p>
    <p class="body">{{ popupContent.description }}</p>
  </div>
</template>

<script>
export default {
  props: {
    popupContent: Object,
  },
};
</script>

<style lang="sass" scoped>
p
  margin: 0
  direction: ltr
.title
  font-size: 28px
  line-height: 38px
  margin-bottom: 20px
.body
  font-size: 15px
  line-height: 22px
</style>
